export const PENDING_ACCOUNTS_KEY = 'F2EX_PENDING_ACCOUNTS_STORE';
export const PENDING_ACCOUNTS_UPDATE_INTERVAL = 5000;
